
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const GoogleSlidesToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/GoogleSlidesToFigma"
        ogImage="/images/googleslides2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/GoogleSlidesToFigma:title")}
        subtitle={t("page/GoogleSlidesToFigma:subtitle")}
        magicianLogoFile="figma"
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/GoogleSlidesToFigma:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/google-slides-to-figma.png",
          alt: "Google Slides to Figma converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.signUp"),
        }}
        elements={t(
          "page/GoogleSlidesToFigma:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />
      <VideoSection
        title={t("page/GoogleSlidesToFigma:section/videoSection.title")}
        subtitle={
          ((
            <Trans
              i18nKey="page/GoogleSlidesToFigma:section/videoSection.subtitle"
              components={[
                <p key="0" />,
                <p key="1" style={{ paddingTop: 20 }} />,
              ]}
            />
          ) as unknown) as string
        }
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/google-slides-image.jpg",
        }}
        cta={{
          title: t("common:actions.signUp"),
          scrollToId: "upload",
        }}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.convertsComponentsSymbols"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "GOOGLE-SLIDES",
            image: "/images/google-slides-preview.jpg",
            title: "Google Slides Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/figma-preview-slides.jpg",
            title: "Figma Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default GoogleSlidesToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/google-slides-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  